import React from 'react';

import { StringParam, useQueryParams } from 'use-query-params';

import { ICardMasksForm } from 'api/blacklists/types';
import { FILTER_OPERATIONS } from 'components/Grids/DataGrid/Filters/utils/types';
import { usePageNavigation } from 'hooks/usePageNavigation';
import { useGetClientsInstruments } from 'queries/clients';

const pageKey = 'CLIENT_CARD_MASK_INSTRUMENT';

export const useGetClientInstrumentsData = () => {
  const [query] = useQueryParams({
    cardPanId: StringParam,
    customerId: StringParam,
    merchantTerminalId: StringParam,
  });

  const initialFilters = React.useMemo(
    () => ({
      search: {
        cardPanId: {
          operation: FILTER_OPERATIONS.EQUALS,
          value: query.cardPanId,
        },
        'customer.merchantCustomerId': {
          operation: FILTER_OPERATIONS.EQUALS,
          value: query.customerId,
        },
        'merchantTerminal.id': {
          operation: FILTER_OPERATIONS.EQUALS,
          value: query.merchantTerminalId,
        },
      },
    }),
    [query],
  );

  const pageFiltersConfig = usePageNavigation({
    initialFilters,
    pageKey,
    saveInitialSearch: true,
  });

  const { data, isLoading } = useGetClientsInstruments(pageFiltersConfig.pageFilters);

  const initialValues = React.useMemo(() => {
    const clientInstrument = data?.data[0];

    const [bin, lastFour] = (clientInstrument?.maskedCardPan || '').split('...');

    return (
      clientInstrument &&
      ({
        bin,
        customerId: clientInstrument?.customer?.merchantCustomerId,
        lastFour,
        merchantId: clientInstrument?.merchantTerminal?.merchant?.id,
        merchantTerminalIds: clientInstrument?.merchantTerminal?.id
          ? [clientInstrument?.merchantTerminal?.id]
          : undefined,
      } as ICardMasksForm)
    );
  }, [data?.data[0]]);

  return { initialValues, isLoading };
};
